/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInstrumentLinkByCustomerAndLinkToken} from '../api'

 export const useQueryGetInstrumentLinkByCustomerAndLinkToken = createReactQueryHook('getInstrumentLinkByCustomerAndLinkToken', getInstrumentLinkByCustomerAndLinkToken)
